// API Configuration - reads from environment variable
// In development: uses REACT_APP_API_BASE_URL from .env.development
// In production: uses REACT_APP_API_BASE_URL from .env.production
// Fallback: production URL (safe default for deployed builds)
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://schedulerapi.appstaging.biz';
